/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { InnerBlocks } from '@wordpress/block-editor';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';
import metadata from './block.json';
import { GrTextWrap } from "react-icons/gr";
import './style.scss';
import settings from './settings/settings.json';
const { name } = metadata;
registerBlockType( name, {
	attributes: {
            ...metadata.attributes, // Keep existing attributes from block.json
            ...settings
        },
	icon: <GrTextWrap style={{color:'#6c1bc3'}} />,
    edit: Edit,
    save: Save,
} );